import { forwardRef } from 'react';

import { useGetProductsTripletexQuery } from '@client/api';
import { Select, SelectProps } from '@client/toolkit';

export const TripletexProductSelect = forwardRef<HTMLSelectElement, Omit<SelectProps, 'ref'>>(
  (props, ref) => {
    const { data: tripletexProducts, isFetching } = useGetProductsTripletexQuery();

    return (
      <Select {...props} ref={ref} disabled={props.disabled || isFetching}>
        <option value=""></option>
        {(tripletexProducts ?? []).map((p) => (
          <option key={p.id} value={String(p.id)}>
            {p.id}{p.name ? ` (${p.name})` : ''}
          </option>
        ))}
      </Select>
    );
  },
);

TripletexProductSelect.displayName = 'TripletexProductSelect';
